export const dbTabs1 = {
  presentation: {
    descriptionTitle: "Description de l'annonce",
    descriptionSub: "Choisissez si la description apparaît sur la page de réservation directe pour chaque unité.",
    visible: "Visible",
    hidden: "Masqué",
    amenitiesTitle: "Services inclus",
    amenitiesSub: "Définissez quels services et équipements sont affichés pour chaque unité dans votre moteur de réservation.",
    amenitiesCount: "{count} service | {count} services",
    editAmenitiesTitle: "Modifier les services",
    edit: "Modifier",
    imagesTitle: "Images de l'hébergement",
    imagesSubtitle: "Téléchargez, réorganisez et définissez l'image principale de chaque unité qui apparaîtra dans votre moteur de réservation.",
  },
  reservations: {
    updating: "Mise à jour…",
    engineActive: "Moteur actif",
    engineInactive: "Moteur inactif",
    engineActiveDesc: "Les clients peuvent réserver des chambres directement depuis votre lien.",
    engineInactiveDesc: "Les réservations directes sont désactivées pour cet hôtel.",
    statusActive: "Actif",
    statusInactive: "Inactif",
    roomsAvailable: "Chambres disponibles",
    colRoom: "Chambre",
    colCap: "Cap.",
    colActive: "Actif",
    noRooms: "Aucune chambre configurée.",
    hotelLabel: "Hôtel",
    unitActive: "Actif",
    unitInactive: "Inactif",
    enableNotice: "Activez les réservations directes pour gérer les chambres.",
    toastUpdated: "Mis à jour.",
    toastUpdateError: "Impossible de mettre à jour.",
    toastGlobalUpdated: "Statut global mis à jour.",
  },
  promotions: {
    title: "Promotions sur la réservation directe",
    subtitle: "Contrôlez lesquelles sont actives, si elles peuvent se cumuler et leur ordre.",
    loading: "Chargement des promotions…",
    empty: "Aucune promotion configurée pour cet établissement.",
    dragTitle: "Faites glisser pour réorganiser",
    switchTitle: "Active sur la réservation directe",
    badgeLabel: "Badge",
    badgePlaceholder: "ex. -10 % / Offre",
    stackableLabel: "Cumulable",
    tip: "Astuce : activez la promotion pour l'appliquer sur la réservation directe et utilisez « Cumulable » si elle peut se combiner avec d'autres promos.",
    toastLoadError: "Impossible de charger les promotions.",
    toastSaved: "Promotions enregistrées avec succès.",
    toastSaveError: "Impossible d'enregistrer les promotions.",
    dateFrom: "À partir du {date}",
    dateUntil: "Jusqu'au {date}",
  },
  addons: {
    title: "Occupation et suppléments",
    hint1: "Un seul ajustement par {scope} : réduction pour moins de clients",
    hintOr: "ou",
    hint2: "supplément par client supplémentaire. Pas les deux.",
    perRoom: "chambre",
    perAccommodation: "hébergement",
    loading: "Chargement de la configuration…",
    emptyHotel: "Cet hôtel n'a aucune chambre configurée.",
    thisAccommodation: "Cet hébergement",
    modeReduction: "Réduction",
    modeSurcharge: "Supplément",
    modeNone: "Aucun ajustement",
    toastLoadError: "Impossible de charger la configuration de l'occupation.",
    toastSaved: "Occupation enregistrée avec succès.",
    toastSaveError: "Impossible d'enregistrer l'occupation.",
  },
};
